import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
export function FinalCTA() {
  return <section className="bg-primary text-white relative overflow-hidden" data-id="element-227">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-228" />
      <div className="absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: 'radial-gradient(var(--color-gold) 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-229" />

      <div className="container-custom py-16 md:py-24 relative z-10" data-id="element-230">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-231">
          <div data-id="element-232">
            <span className="eyebrow-light" data-id="element-233">Take the quiet first step</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium mb-7 leading-[1.1] text-white text-balance" data-id="element-234">
              A ring. A repair. An heirloom.{' '}
              <span className="italic text-gold-light" data-id="element-235">
                An idea you can't quite name yet.
              </span>
            </h2>

            <p className="text-white/75 text-lg mb-10 leading-relaxed max-w-lg text-pretty" data-id="element-236">
              Start with a conversation — in person at Riseley Square, on the
              phone, or with the form. An experienced jeweller (often James
              himself) will reply personally.
            </p>

            <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 mb-8 max-w-lg" data-id="element-237">
              <a href="tel:0893162321" className="bg-primary hover:bg-navy transition-colors p-5 group" data-id="element-238">
                <div className="flex items-center gap-3 mb-2" data-id="element-239">
                  <PhoneIcon className="w-4 h-4 text-gold-light" data-id="element-240" />
                  <p className="text-[0.6rem] tracking-[0.25em] uppercase text-white/60" data-id="element-241">
                    Phone
                  </p>
                </div>
                <p className="font-serif text-xl text-white group-hover:text-gold-light transition-colors" data-id="element-242">
                  08 9316 2321
                </p>
                <p className="text-xs text-white/50 mt-1" data-id="element-243">
                  Mon–Fri 9–4:30 · Sat 9–1
                </p>
              </a>
              <a href="https://maps.google.com/?q=Sinclairs+Jewellers+Ardross" target="_blank" rel="noopener noreferrer" className="bg-primary hover:bg-navy transition-colors p-5 group" data-id="element-244">
                <div className="flex items-center gap-3 mb-2" data-id="element-245">
                  <MapPinIcon className="w-4 h-4 text-gold-light" data-id="element-246" />
                  <p className="text-[0.6rem] tracking-[0.25em] uppercase text-white/60" data-id="element-247">
                    Visit
                  </p>
                </div>
                <p className="font-serif text-xl text-white group-hover:text-gold-light transition-colors" data-id="element-248">
                  Riseley Square
                </p>
                <p className="text-xs text-white/50 mt-1" data-id="element-249">
                  Shop 5&amp;6, Ardross WA
                </p>
              </a>
            </div>

            <div className="flex items-center gap-3 text-sm text-white/60 italic" data-id="element-250">
              <ClockIcon className="w-4 h-4 text-gold" data-id="element-251" />
              We reply to every enquiry personally — usually within one working
              day.
            </div>
          </div>

          <div className="relative text-primary" data-id="element-252">
            <ContactForm data-id="element-253" />
          </div>
        </div>
      </div>
    </section>;
}